'use strict';

// 版本号比较
// 例如： 1.0 应该小于 2.0
// 1.0 应该小于 1.0.1
// 注意：1.0 应该小于 1.0.0

var cacheHelper = require('./cacheHelper');

function compareVersion(v1, v2) {
  var v1Arr = v1.split('.');
  var v2Arr = v2.split('.');
  var a, b;

  if (v1Arr.length > v2Arr.length) {
    return 1;
  }
  if (v1Arr.length < v2Arr.length) {
    return -1;
  }

  for (var i = 0; i < v1Arr.length; i++) {
    a = parseInt(v1Arr[i], 10);
    b = parseInt(v2Arr[i], 10);

    if (a === b) { // 此位相等，进行下一轮
      continue;
    }
    return a - b;
  }
}

/**
 * src 版本是否低于 dest 版本
 * @param src
 * @param dest
 */
exports.isLowerThan = function (src, dest) {
  return compareVersion(src, dest) < 0;
};

/**
 * src 版本是否高于 dest 版本
 * @param src
 * @param dest
 */
exports.isGreatterThan = function (src, dest) {
  return compareVersion(src, dest) > 0;
};

/**
 * 当前页面版本号是否小于 4.3
 * 此版本位桌面端的 2.2.9 版本，对多个组件属性进行了调整，并且修改了 iPhone, Android, iPad, Tablet 几个组件的渲染效果
 */
exports.isPageVersionLowerThan4_3 = function () {
  var ver = cacheHelper.cache(cacheHelper.keys.PAGE_VERSION);
  return compareVersion(ver, '4.3') < 0;
};
/**
 * 当前页面版本号是否小于 4.5
 * 此版本位桌面端的 2.3.8 版本，扩展了图表和树组件
 */
exports.isPageVersionLowerThan4_5 = function () {
  var ver = cacheHelper.cache(cacheHelper.keys.PAGE_VERSION);
  return compareVersion(ver, '4.5') < 0;
};
/**
 * 当前页面版本号是否小于 4.9
 * 此版本位桌面端的 3.2.6 版本，此版本修改了母版可见性问题
 */
exports.isPageVersionLowerThan4_9 = function () {
  var ver = cacheHelper.cache(cacheHelper.keys.PAGE_VERSION);
  return compareVersion(ver, '4.9') < 0;
};

/**
 * 判断是否是移动项目
 * @returns {boolean}
 */
exports.isMobileApp = function () {
  var platform = cacheHelper.cache(cacheHelper.keys.PLATFORM);
   return platform === 'MtMobile' || platform === 'MtPad';
};


// WEBPACK FOOTER //
// ./src/helper/versionHelper.js